/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6'; // https://github.com/rjsf-team/react-jsonschema-form/blob/master/packages/core/src/utils.js

import { retrieveSchema } from './schemaUtils';
/**
 * This function checks if the given schema matches a single
 * constant value.
 */

export function isConstant(schema) {
  return Array.isArray(schema.enum) && schema.enum.length === 1 || schema.hasOwnProperty('const');
}
export function isSelect(_schema, definitions = {}) {
  const schema = retrieveSchema(_schema, definitions);
  const altSchemas = schema.oneOf || schema.anyOf;

  if (Array.isArray(schema.enum)) {
    return true;
  } else if (Array.isArray(altSchemas)) {
    return altSchemas.every(altSchema => isConstant(altSchema));
  }

  return false;
}
export function isMultiSelect(schema, definitions = {}) {
  if (!schema.uniqueItems || !schema.items) {
    return false;
  }

  return isSelect(schema.items, definitions);
}
export function isFilesArray(schema, definitions = {}) {
  if (schema.items) {
    const itemsSchema = retrieveSchema(schema.items, definitions);
    return itemsSchema.type === 'string' && itemsSchema.format === 'data-url';
  }

  return false;
}